import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=2ebcc7c4"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports